@use "../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .container {
        position: relative;
      }

      .previewButton {
        position: absolute;
        top: -0.25rem;
        right: 0;
      }
    }
  }
}
